import { render } from "./spgl.vue?vue&type=template&id=c31dacf4&scoped=true"
import script from "./spgl.vue?vue&type=script&lang=js"
export * from "./spgl.vue?vue&type=script&lang=js"

import "./spgl.vue?vue&type=style&index=0&id=c31dacf4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c31dacf4"]])

export default __exports__